import { isClientSide } from '../../nextEnv';
import { AbstractScriptLoader } from './AbstractScriptLoader';

class PsoScriptLoader extends AbstractScriptLoader {
  name: string = 'PSO';
  identifier: string = 'techem';
  env: string = 'https://api.pso-empfehlen.net/';

  constructor() {
    super();
  }

  isLoaded(): boolean {
    return isClientSide() && !!(window as any).psoTag;
  }

  load(): Promise<boolean> {
    if (this.isLoaded()) {
      console.warn(`${this.name} script is already attached to DOM.`);
      return Promise.resolve(false);
    }

    const env = this.env.replace(/\/$/, '');

    return new Promise((resolve, reject) => {
      let script: HTMLScriptElement = document.createElement('script');

      script.type = 'text/javascript';
      script.src = `${env}/api/v1/${this.identifier}/tracking/einsprung`;
      //script.defer = true;
      script.setAttribute('data-cookieconsent', 'marketing');
      script.onerror = () => {
        reject(`Failed to load ${this.name} script.`);
      };

      document.body.appendChild(script);
      resolve(true);
    });
  }

  init(initNeeded): Promise<boolean> {
    // Nothing to do right now.
    return Promise.resolve(true);
  }
}

export const PsoTracking = new PsoScriptLoader();
